import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'

export const mediaStoragesApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'mediaStorageApi',
  endpoints: (builder) => ({
    uploadImage: builder.mutation<MediaStorageImage, FormData>({
      query: (body) => ({
        url: 'media_storage/images/',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const useUploadImageMutation = () => {
  return mediaStoragesApi.useUploadImageMutation({ fixedCacheKey: 'uploadImage' })
}
